import Contact from '../../Components/Contact/Contact'
import ZohoId from '../../Components/ZohoId/ZohoId'
import GryvChecklist from '../../Components/GryvChecklist/GryvChecklist'
import useContact from './useContact'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'

const ContactTab = () => {
  const { saveContact, isSaving, t } = useContact()

  return (
    <div style={{ width: '100%' }}>
      <ZohoId />
      <GryvChecklist />
      <Contact />
      <div>
        <SDButton style={{ width: '100%' }} disabled={isSaving} isLoading={isSaving} onClick={saveContact}>
          {t('common:save')}
        </SDButton>
      </div>
    </div>
  )
}

export default ContactTab
